"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeWrapped = exports.measureWrapped = exports.write = exports.writeAbsolute = exports.drawBackground = exports.getSprite = void 0;
var rogueColors_1 = require("@dive/colors/rogueColors");
var mathUtils_1 = require("@lib/mathUtils");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var rogueGlyphs_1 = require("./rogueGlyphs");
var rogueGlyphs_sidecar_1 = require("./rogueGlyphs-sidecar");
var rogueMonofont_fontMap_1 = require("./rogueMonofont_fontMap");
var rogueMonofont_letterSizeMap_1 = require("./rogueMonofont_letterSizeMap");
var rogueMonofont_scales_1 = require("./rogueMonofont_scales");
var spriteBack = sprites_sidecar_1.sprites.monofont72;
// export interface IMonofontGlyph {
//   x: number
//   y: number
//   char: string
//   frames: ISPD[]
//   image: PImage
//   visible: boolean
// }
// const objs: IMonofontGlyph[] = []
var _idx = 0;
// const objsVisible: IMonofontGlyph[] = []
// export const create = () => {
//   if (_idx < objs.length) {
//     return objs[_idx++]
//   }
//   let image = spritesUtil.createImage(
//     rogueLayers.getLayers().ui1,
//     sprites.monofont64[0],
//   )
//   image.scale = rogueDef.scale
//   const c: IMonofontGlyph = {
//     x: 0,
//     y: 0,
//     char: '?',
//     frames: sprites.monofont64,
//     image,
//     visible: true,
//   }
//   _idx++
//   objs.push(c)
//   return c
// }
// export const setPos = (c: IRogueGlyph, x: number, y: number) => {
//   c.x = x
//   c.y = y
// }
var getSprite = function (c) {
    return rogueMonofont_fontMap_1.fontMap[c] || rogueMonofont_fontMap_1.fontMap._default;
};
exports.getSprite = getSprite;
var drawBackground = function (x, y, colorBack, liveFor) {
    if (liveFor === void 0) { liveFor = 0; }
    if (colorBack !== rogueColors_1.rogueColors.none) {
        rogueGlyphs_sidecar_1.rogueGlyphs.writeBg(x, y, colorBack, spriteBack, liveFor);
        // let cBack = rogueGlyphs.create()
        // rogueGlyphs.setPos(cBack, x, y)
        // cBack.char = 'back'
        // spritesUtil.setPackedFrameSameScale(cBack.image, spriteBack[0])
        // cBack.image.tint = colorBack
        // cBack.visible = true
    }
};
exports.drawBackground = drawBackground;
var writeAbsolute = function (x, y, text, color, colorBack) {
    if (color === void 0) { color = rogueColors_1.rogueColors.light; }
    if (colorBack === void 0) { colorBack = rogueColors_1.rogueColors.none; }
    x /= rogueGlyphs_1.rogueDef.sizeX;
    y /= rogueGlyphs_1.rogueDef.sizeY;
    return exports.write(x, y, text, color, colorBack, null, null, null, '', 0);
};
exports.writeAbsolute = writeAbsolute;
var write = function (x, y, text, color, colorBack, onClick, onHover, hotkey, effect, liveFor, isMonoFont) {
    if (color === void 0) { color = rogueColors_1.rogueColors.light; }
    if (colorBack === void 0) { colorBack = rogueColors_1.rogueColors.none; }
    if (onClick === void 0) { onClick = null; }
    if (onHover === void 0) { onHover = null; }
    if (hotkey === void 0) { hotkey = null; }
    if (effect === void 0) { effect = ''; }
    if (liveFor === void 0) { liveFor = 0; }
    if (isMonoFont === void 0) { isMonoFont = false; }
    var isWave = effect === 'wave';
    var isRainbow = effect === 'rainbow';
    var isFire = effect === 'fire';
    var isWater = effect === 'water';
    if (effect === 'rainbowwave') {
        isWave = true;
        isRainbow = true;
    }
    var elapsed = common_sidecar_1.common.getElapsedTime();
    var adjustX = 0;
    var adjustY = 0;
    if (colorBack !== rogueColors_1.rogueColors.none) {
        // TODO: restore this button functionality
        // if (rogueMouseAreas.isOver(x, y, text.length, 1)) {
        //   colorBack = rogueColors.lightBlue
        // }
    }
    var ox = 0;
    var defaultSize = rogueMonofont_letterSizeMap_1.letterSizeMap._default;
    for (var i = 0; i < text.length; i++) {
        var size = isMonoFont ? [1, 0] : rogueMonofont_letterSizeMap_1.letterSizeMap[text[i]] || defaultSize;
        var xSize = size[0] / 2;
        var xLeading = xSize * size[1];
        var xTrailing = xSize - xLeading;
        ox += xLeading;
        if (colorBack !== rogueColors_1.rogueColors.none) {
            exports.drawBackground(x + ox, y, colorBack, liveFor);
        }
        var c = rogueGlyphs_sidecar_1.rogueGlyphs.create();
        var yo = 0;
        var ch = text[i];
        var famkey = ch;
        if (rogueMonofont_fontMap_1.fontAdjustMap[famkey]) {
            // console.log('adjust', famkey, fontAdjustMap[famkey])
            adjustX = (rogueMonofont_fontMap_1.fontAdjustMap[famkey][0] * 1) / 8;
            adjustY = (rogueMonofont_fontMap_1.fontAdjustMap[famkey][1] * 1) / 8;
        }
        else {
            adjustX = 0;
            adjustY = 0;
        }
        if (isWave) {
            yo = Math.sin(elapsed * 4 + 0.5 * (x + ox + y)) * 0.2;
        }
        if (isRainbow) {
            color =
                rogueMonofont_scales_1.rainbowScale[mathUtils_1.betterMod(x + ox + y - Math.floor(elapsed / 0.1), rogueMonofont_scales_1.rainbowScale.length)];
        }
        if (isFire) {
            color =
                rogueMonofont_scales_1.fireScale[mathUtils_1.betterMod(x + ox + y - Math.floor(elapsed / 0.1), rogueMonofont_scales_1.fireScale.length)];
        }
        if (isWater) {
            color =
                rogueMonofont_scales_1.waterScale[mathUtils_1.betterMod(x + ox + y - Math.floor(elapsed / 0.1), rogueMonofont_scales_1.waterScale.length)];
        }
        rogueGlyphs_sidecar_1.rogueGlyphs.write(x + ox + adjustX, y + yo + adjustY, text[i], color, liveFor);
        // rogueGlyphs.setPos(c, x + i, y + yo)
        // c.char = text[i]
        // // Update sprite
        // spritesUtil.setPackedFrameSameScale(c.image, getSprite(c.char)[0])
        // c.image.tint = color
        // c.visible = true
        ox += xTrailing;
    }
    if (onClick) {
        // const onHover = () => {
        //   console.log('hover', text)
        //   write(x + 1, y, text, color, rogueColors.lightBlue)
        // }
        // TODO: restore this button functionality
        // rogueMouseAreas.create(x, y, text.length, 1, onHover, onClick)
        // if (hotkey) {
        //   rogueHotkeys.create(hotkey, onClick)
        // }
    }
    return text.length;
};
exports.write = write;
var measureWrapped = function (width, text) {
    return exports.writeWrapped(0, 0, width, text, rogueColors_1.rogueColors.none, rogueColors_1.rogueColors.none, 9999, true);
};
exports.measureWrapped = measureWrapped;
var writeWrapped = function (x, y, width, text, color, colorBack, elapsed, measureOnly) {
    if (color === void 0) { color = rogueColors_1.rogueColors.light; }
    if (colorBack === void 0) { colorBack = rogueColors_1.rogueColors.none; }
    if (elapsed === void 0) { elapsed = 9999; }
    if (measureOnly === void 0) { measureOnly = false; }
    var colorStack = [];
    var effect = '';
    var xs = x;
    var xe = x + width - 1;
    var ys = y;
    // get chunks
    var chunks = [];
    var chunk = '';
    var addChunk = function () {
        var len = chunk.length;
        if (chunk) {
            chunks.push({
                text: chunk,
                x: x,
                color: color,
                y: y,
                effect: effect,
            });
            chunk = '';
        }
        return len;
    };
    var isInCommandReadMode = false;
    var changedColor = false;
    var command = '';
    for (var i = 0; i < text.length; i++) {
        var c = text[i];
        if (isInCommandReadMode) {
            if (c === '|') {
                isInCommandReadMode = false;
                if (command.startsWith('color:')) {
                    var colorText = command.substring('color:'.length);
                    var num = parseInt(colorText);
                    colorStack.push(color);
                    changedColor = true;
                    color = num;
                }
                else if (command === 'red') {
                    colorStack.push(color);
                    changedColor = true;
                    color = rogueColors_1.rogueColors.red;
                }
                else if (command === 'yellow') {
                    colorStack.push(color);
                    changedColor = true;
                    color = rogueColors_1.rogueColors.yellow;
                }
                else if (command === 'orange') {
                    colorStack.push(color);
                    changedColor = true;
                    color = rogueColors_1.rogueColors.orange;
                }
                else if (command === 'green') {
                    colorStack.push(color);
                    changedColor = true;
                    color = rogueColors_1.rogueColors.green;
                }
                else if (command === 'lightBlue') {
                    colorStack.push(color);
                    changedColor = true;
                    color = rogueColors_1.rogueColors.lightBlue;
                }
                else if (command === 'black') {
                    colorStack.push(color);
                    changedColor = true;
                    color = rogueColors_1.rogueColors.pureBlack;
                }
                else if (command === 'dark') {
                    colorStack.push(color);
                    changedColor = true;
                    color = rogueColors_1.rogueColors.dark;
                }
                else if (command === 'wave') {
                    effect = 'wave';
                }
                else if (command === 'water') {
                    effect = 'water';
                }
                else if (command === 'rainbow') {
                    effect = 'rainbow';
                }
                else if (command === 'fire') {
                    effect = 'fire';
                }
                else if (command === 'rainbowwave') {
                    effect = 'rainbowwave';
                }
                else {
                    console.warn('Unknown text formatting command', command);
                }
                continue;
            }
            if (c === ']') {
                isInCommandReadMode = false; // end early?
                continue;
            }
            else {
                command += c;
                continue;
            }
        }
        if (c === '[') {
            // Start reading command
            x += addChunk();
            isInCommandReadMode = true;
            command = '';
            continue;
        }
        if (c === ']') {
            // Pop color / effect and end chunk
            x += addChunk();
            if (changedColor) {
                color = colorStack.pop() || rogueColors_1.rogueColors.light;
                changedColor = false;
            }
            effect = '';
            continue;
        }
        if (c === ' ' || c === '\n' || c === '\r') {
            x += addChunk() + 1;
            if (c === '\n') {
                y++;
                x = xs;
            }
        }
        else {
            chunk += c;
        }
        // Newline detection
        if (x + chunk.length > xe + 1) {
            if (x === xs) {
                addChunk();
            }
            x = xs;
            y++;
        }
    }
    addChunk();
    var ye = y;
    var maxBack = elapsed / 0.002;
    var idxBack = 0;
    if (colorBack !== rogueColors_1.rogueColors.none) {
        for (var j = ys; j <= ye; j++) {
            for (var i = xs; i <= xe; i++) {
                idxBack++;
                if (idxBack > maxBack) {
                    break;
                }
                exports.drawBackground(i, j, colorBack);
            }
            if (idxBack > maxBack) {
                break;
            }
        }
    }
    var maxChars = elapsed / 0.02; //0.0125
    var idxChars = 0;
    if (!measureOnly) {
        chunks.forEach(function (c) {
            if (idxChars > maxChars) {
                return false;
            }
            idxChars += c.text.length;
            if (idxChars > maxChars) {
                var remaining = maxChars - idxChars + c.text.length;
                var remainingText = c.text.substring(0, remaining);
                if (remainingText) {
                    exports.write(c.x, c.y, remainingText, c.color, rogueColors_1.rogueColors.none, null, null, null, c.effect);
                }
                return false;
            }
            else {
                exports.write(c.x, c.y, c.text, c.color, rogueColors_1.rogueColors.none, null, null, null, c.effect);
            }
        });
    }
    var w = xe - xs + 1;
    var h = ye - ys + 1 + 1;
    return { w: w, h: h };
};
exports.writeWrapped = writeWrapped;
// export const drawAll = () => {
//   objs.forEach((c) => {
//     c.image.x = c.x * rogueDef.sizeX
//     c.image.y = c.y * rogueDef.sizeY
//     c.image.visible = c.visible
//     c.visible = false // reset
//   })
//   _idx = 0
// }
